// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedWorkpassOccupation: null
}

const workpassOccupations = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_WORKPASS_OCCUPATIONS_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_WORKPASS_OCCUPATIONS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_WORKPASS_OCCUPATIONS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_WORKPASS_OCCUPATION':
      return { ...state, selectedWorkpassOccupation: action.selectedWorkpassOccupation }
    case 'ADD_WORKPASS_OCCUPATION':
      return { ...state }
    case 'DELETE_WORKPASS_OCCUPATION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default workpassOccupations
